import { render, staticRenderFns } from "./ModuleFive.vue?vue&type=template&id=7b089d78&scoped=true"
import script from "./ModuleFive.vue?vue&type=script&lang=js"
export * from "./ModuleFive.vue?vue&type=script&lang=js"
import style0 from "./ModuleFive.vue?vue&type=style&index=0&id=7b089d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b089d78",
  null
  
)

export default component.exports